import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../api";
import { Scanner } from "@yudiel/react-qr-scanner";

import { useI18n } from "../i18n/I18nContext";

function isAndroid() { return /Android/i.test(navigator.userAgent || ""); }
function normalize(text) {
  return text.toString().toLowerCase().normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, " ").trim();
}
function cleanPart(v) { return String(v || "").trim().replace(/\s+/g, " "); }

export default function LivraisonProduitQualite() {
  const { t, ui } = useI18n();

  const navigate = useNavigate();

  const [operator, setOperator]             = useState("");
  const [now, setNow]                       = useState(new Date());
  const [stackPn, setStackPn]               = useState("");
  const [stackSearch, setStackSearch]       = useState("");
  const [stackList, setStackList]           = useState([]);
  const [showStackList, setShowStackList]   = useState(false);
  const [showScanner, setShowScanner]       = useState(false);
  const stackBoxRef                         = useRef(null);
  const [traitementMeca, setTraitementMeca]         = useState("");
  const [traitementEnrobage, setTraitementEnrobage] = useState("");
  const [autresFinitions, setAutresFinitions]       = useState("");
  const [defCourbure, setDefCourbure]   = useState("");
  const [defSurface, setDefSurface]     = useState("");
  const [autresDefauts, setAutresDefauts] = useState("");
  const [longueur, setLongueur]   = useState("");
  const [largeur, setLargeur]     = useState("");
  const [poids, setPoids]         = useState("");
  const [ep1, setEp1] = useState(""); const [ep2, setEp2] = useState("");
  const [ep3, setEp3] = useState(""); const [ep4, setEp4] = useState("");
  const [ep5, setEp5] = useState("");
  const [controle, setControle]     = useState("");
  const [nomProjet, setNomProjet]   = useState("");
  const [nomPiece, setNomPiece]     = useState("");
  const [etage, setEtage]           = useState("");
  const [materiaux, setMateriaux]   = useState("");
  const [facade, setFacade]         = useState("");
  const [transport, setTransport]   = useState("");
  const [comments, setComments]     = useState("");
  const [sending, setSending]       = useState(false);
  const [printing, setPrinting]     = useState(false);
  const [error, setError]           = useState("");
  const [success, setSuccess]       = useState("");
  const [qrValue, setQrValue]       = useState("");

  useEffect(() => {
    const raw = localStorage.getItem("user");
    if (raw) { try { setOperator(JSON.parse(raw).username || ""); } catch {} }
  }, []);

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  async function reloadStacks() {
    try {
      const res  = await apiFetch("/api/aboutage/list");
      if (!res.ok) return;
      const data = await res.json().catch(() => ({}));
      const raw  = Array.isArray(data) ? data : Array.isArray(data.items) ? data.items : [];
      const all  = raw.map((it) => typeof it === "string" ? it : it.FinalStackId || it.stackId || it.StackId || "")
                      .map((x) => String(x).trim()).filter(Boolean);
      setStackList(Array.from(new Set(all)));
    } catch (e) { console.error(e); }
  }
  useEffect(() => { reloadStacks(); }, []);

  useEffect(() => {
    function onDown(e) { if (stackBoxRef.current && !stackBoxRef.current.contains(e.target)) setShowStackList(false); }
    document.addEventListener("mousedown", onDown);
    document.addEventListener("touchstart", onDown);
    return () => { document.removeEventListener("mousedown", onDown); document.removeEventListener("touchstart", onDown); };
  }, []);

  const filteredStacks = useMemo(() => {
    const s = normalize(stackSearch);
    return stackList.filter((p) => !s || normalize(p).includes(s));
  }, [stackSearch, stackList]);

  function handleScan(results) {
    if (!results?.length) return;
    const val = (results[0].rawValue || "").trim();
    if (!val) return;
    setStackPn(val); setStackSearch(val); setShowStackList(false); setShowScanner(false);
  }

  async function clientPrintFromApi(bodyForApi) {
    const win = window.open("", "_blank");
    if (win) { win.document.write(`<!doctype html><title>Préparation…</title><body>Préparation…</body>`); win.document.close(); }
    const res = await apiFetch("/api/labels/a4", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ ...bodyForApi, format: "PNG", download: false }) });
    if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.message || `HTTP ${res.status}`); }
    const blob     = await res.blob();
    const blobUrl  = URL.createObjectURL(blob);
    const safePN   = String(bodyForApi.pn || "QR").replace(/[^\w\-]+/g, "_").slice(0, 64);
    const fileName = `A4_${bodyForApi.n || 1}x_${safePN}.png`;
    if (!win) { const a = document.createElement("a"); a.href = blobUrl; a.download = fileName; a.click(); URL.revokeObjectURL(blobUrl); return; }
    const AND = isAndroid();
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>${fileName}</title>
    <style>html,body{height:100%;margin:0}
    #bar{position:fixed;inset:auto 0 0 0;background:#111;color:#fff;padding:8px;display:flex;gap:8px;align-items:center;z-index:10}
    #bar button,#bar a{background:#E6FF3E;color:#000;border:0;padding:8px 12px;font-weight:800;cursor:pointer;text-decoration:none}
    .v{position:fixed;left:0;right:0;top:0;bottom:44px;width:100%;object-fit:contain;background:#fff}
    </style></head><body>
    <img class="v" src="${blobUrl}" alt=""/>
    <div id="bar">
      ${AND ? "" : "<button id='btnPrint'>Imprimer</button>"}
      <a href="${blobUrl}" download="${fileName}">Télécharger</a>
      <button id="btnClose">Fermer</button>
    </div>
    <script>
      ${AND ? "" : "btnPrint.onclick=()=>{try{window.focus();window.print();}catch(e){}};"}
      btnClose.onclick=()=>{try{URL.revokeObjectURL('${blobUrl}');}catch(e){};setTimeout(()=>window.close(),100);};
      window.onafterprint=()=>{try{URL.revokeObjectURL('${blobUrl}');}catch(e){};setTimeout(()=>window.close(),200);};
      ${AND ? "" : "setTimeout(()=>{try{window.focus();window.print();}catch(e){}},400);"}
    </script></body></html>`;
    win.document.open(); win.document.write(html); win.document.close();
  }

  async function handleCreateQR() {
    setError(""); setSuccess("");
    if (!stackPn) return setError("Merci de sélectionner le Parc number Stack Abouté.");
    if (!nomProjet || !nomPiece || !etage || !facade || !poids || !transport || !materiaux)
      return setError("Merci de remplir : Nom du Projet, Nom de la pièce, Etage, Facade, Poids, Transport, Materiaux.");
    const qr = [nomProjet, nomPiece, etage, facade, poids, transport, materiaux].map(cleanPart).join("-");
    setQrValue(qr);
    setSuccess("✅ QR créé. Cliquez sur Print QR pour imprimer.");
  }

  async function handlePrintQR() {
    setError(""); setSuccess("");
    if (!stackPn)  return setError("Merci de sélectionner le Parc number Stack Abouté.");
    if (!qrValue)  return setError("Merci de cliquer d'abord sur Save & Create QR.");
    try {
      setPrinting(true);
      await clientPrintFromApi({ n: 2, pn: qrValue, detail: `STACK Abouté - Quality check (${stackPn})`, date: new Date().toISOString().split("T")[0] });
      setSuccess("✅ QR imprimé.");
    } catch (e) { setError(e.message || "Erreur impression"); }
    finally { setPrinting(false); }
  }

  async function handleSubmit(e) {
    e.preventDefault(); setError(""); setSuccess("");
    if (!stackPn)  return setError("Merci de sélectionner le Parc number Stack Abouté.");
    if (!controle) return setError("Merci de choisir OK ou NOK.");
    const payload = {
      operator, stackPn,
      traitements: { traitementMecanique: traitementMeca, traitementEnrobage, autresFinitions },
      defauts:     { defautCourbureComment: defCourbure, defautSurfaceComment: defSurface, autresDefautsComment: autresDefauts },
      dimensions:  { longueur, largeur, poids, epaisseur1: ep1, epaisseur2: ep2, epaisseur3: ep3, epaisseur4: ep4, epaisseur5: ep5 },
      controle,
      infos:       { nomProjet, nomPiece, etage, materiaux, facade, transport, comments },
      qrValue, timestamp: new Date().toISOString(), source: "LivraisonProduitQualiteCheck",
    };
    try {
      setSending(true);
      const res = await apiFetch("/api/livraison-produit/qualite-check", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
      if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(d.message || "Erreur serveur"); }
      setTraitementMeca(""); setTraitementEnrobage(""); setAutresFinitions("");
      setDefCourbure(""); setDefSurface(""); setAutresDefauts("");
      setLongueur(""); setLargeur(""); setPoids("");
      setEp1(""); setEp2(""); setEp3(""); setEp4(""); setEp5("");
      setControle(""); setNomProjet(""); setNomPiece(""); setEtage("");
      setMateriaux(""); setFacade(""); setTransport(""); setComments("");
      setQrValue(""); setSuccess("✅ Données enregistrées avec succès.");
    } catch (e) { setError("❌ " + (e.message || "Erreur d'envoi.")); }
    finally { setSending(false); }
  }

  const timeStr = now.toLocaleTimeString("fr-FR");
  const dateStr = now.toLocaleDateString("fr-FR", { weekday: "short", day: "2-digit", month: "short", year: "numeric" });

  return (
    <div className="lq-page">
      <div className="lq-card">

        {/* HEADER */}
        <div className="lq-header">
          <span>Livraison de Produit</span>
          <span className="lq-header-sub">Finition · Visuel · Qualité Check</span>
        </div>

        {/* NAV */}
        <div className="lq-nav">
          <button type="button" className="lq-btn-back" onClick={() => navigate("/menu")}>← Retour menu</button>
          <div className="lq-clock">
            <div className="lq-clock-time">{timeStr}</div>
            <div className="lq-clock-date">{dateStr}</div>
          </div>
        </div>

        {/* OPÉRATEUR + STACK PN */}
        <div className="lq-topbar">
          <div className="lq-operator">
            <span className="lq-operator-dot" />
            {operator ? operator.toUpperCase() : "OPÉRATEUR NON CONNECTÉ"}
          </div>

          <div ref={stackBoxRef} className="lq-stack-box">
            <div className="lq-chip-red">📦 Parc number Stack_Abouté</div>
            <div className="lq-stack-row">
              <div style={{ flex: 1, position: "relative" }}>
                <input value={stackSearch}
                  onChange={(e) => { setStackSearch(e.target.value); setShowStackList(true); }}
                  onFocus={() => setShowStackList(true)}
                  placeholder="Scan et/ou manuel"
                  className="lq-select-input" />
                {stackPn && (
                  <div className="lq-selected-badge">
                    <span>✔</span><strong>{stackPn}</strong>
                    <button type="button" className="lq-clear-btn" onClick={() => { setStackPn(""); setStackSearch(""); }}>✕</button>
                  </div>
                )}
                {showStackList && filteredStacks.length > 0 && (
                  <div className="lq-dropdown" onMouseDown={(e) => e.preventDefault()}>
                    {filteredStacks.map((p) => (
                      <div key={p} className="lq-dropdown-item"
                        onClick={() => { setStackPn(p); setStackSearch(p); setShowStackList(false); }}>{p}</div>
                    ))}
                  </div>
                )}
              </div>
              <button type="button" className="lq-scan-btn" onClick={() => setShowScanner(true)} title="Scanner QR">📷</button>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="lq-form">

          {/* TRAITEMENTS */}
          <div className="lq-section">
            <div className="lq-section-label">🔧 Traitements & Finitions</div>
            <div className="lq-grid-3">
              <YellowBox label="Traitement mécanique"          value={traitementMeca}      onChange={setTraitementMeca} />
              <YellowBox label={"Traitement enrobage\n(vernis…)"} value={traitementEnrobage} onChange={setTraitementEnrobage} />
              <YellowBox label="Autres finitions…"             value={autresFinitions}     onChange={setAutresFinitions} />
            </div>
          </div>

          {/* DÉFAUTS */}
          <div className="lq-section">
            <div className="lq-section-label lq-label-green">⚠️ Défauts & Commentaires</div>
            <div className="lq-defauts-grid">
              <GreenTag>Défaut de courbure</GreenTag>
              <input value={defCourbure}   onChange={(e) => setDefCourbure(e.target.value)}   className="lq-gray-input" placeholder="Commentaire…" />
              <GreenTag>Défauts de surface</GreenTag>
              <input value={defSurface}    onChange={(e) => setDefSurface(e.target.value)}    className="lq-gray-input" placeholder="Commentaire…" />
              <GreenTag>Autres défauts</GreenTag>
              <input value={autresDefauts} onChange={(e) => setAutresDefauts(e.target.value)} className="lq-gray-input" placeholder="Commentaire…" />
            </div>
          </div>

          {/* DIMENSIONS */}
          <div className="lq-section">
            <div className="lq-section-label lq-label-gray">📐 Dimensions & Mesures</div>
            <div className="lq-grid-3">
              <DimField label="Longueur"   value={longueur} onChange={setLongueur} />
              <DimField label="Largeur"    value={largeur}  onChange={setLargeur} />
              <DimField label="Poids (kg)" value={poids}    onChange={setPoids} />
            </div>
            <div className="lq-grid-5">
              {[["Épaisseur 1", ep1, setEp1], ["Épaisseur 2", ep2, setEp2], ["Épaisseur 3", ep3, setEp3],
                ["Épaisseur 4", ep4, setEp4], ["Épaisseur 5", ep5, setEp5]].map(([l, v, s]) => (
                <DimField key={l} label={l} value={v} onChange={s} small />
              ))}
            </div>
          </div>

          {/* CONTRÔLE OK / NOK */}
          <div className="lq-section">
            <div className="lq-section-label">✅ Contrôle final</div>
            <div className="lq-grid-2">
              <button type="button" onClick={() => setControle("OK")}
                className={`lq-ctrl-btn lq-ctrl-ok ${controle === "OK" ? "lq-ctrl-active" : ""}`}>
                STACK Finale Contrôle Test<br />Complete <strong>OK</strong>
              </button>
              <button type="button" onClick={() => setControle("NOK")}
                className={`lq-ctrl-btn lq-ctrl-nok ${controle === "NOK" ? "lq-ctrl-active" : ""}`}>
                STACK Finale Contrôle Test<br />Complete <strong>NOK</strong>
              </button>
            </div>
          </div>

          {/* INFOS PROJET */}
          <div className="lq-section">
            <div className="lq-section-label lq-label-gray">🏗 Informations Projet</div>
            <div className="lq-grid-3">
              <MiniField label="Nom du Projet"   value={nomProjet}  onChange={setNomProjet} />
              <MiniField label="Nom de la pièce" value={nomPiece}   onChange={setNomPiece} />
              <MiniField label="Etage"           value={etage}      onChange={setEtage} />
              <MiniField label="Materiaux"       value={materiaux}  onChange={setMateriaux} />
              <MiniField label="Facade"          value={facade}     onChange={setFacade} />
              <MiniField label="Transport"       value={transport}  onChange={setTransport} />
            </div>
            <div>
              <div className="lq-mini-label">💬 Comments</div>
              <input value={comments} onChange={(e) => setComments(e.target.value)} className="lq-wide-input" placeholder="Observations générales…" />
            </div>
          </div>

          {/* QR */}
          <div className="lq-section lq-section-qr">
            <div className="lq-section-label">🔖 QR Code</div>
            {qrValue && <div className="lq-qr-preview">{qrValue}</div>}
            <div className="lq-grid-2">
              <button type="button" onClick={handleCreateQR} className="lq-btn-qr-create">
                💾 Save & Create QR
              </button>
              <button type="button" onClick={handlePrintQR} disabled={printing} className="lq-btn-qr-print">
                {printing ? "⏳ Impression…" : "🖨 Print QR"}
              </button>
            </div>
          </div>

          {/* MESSAGES */}
          {error   && <div className="lq-msg lq-msg-error">{error}</div>}
          {success && <div className="lq-msg lq-msg-success">{success}</div>}

          {/* SUBMIT */}
          <div className="lq-submit-row">
            <button type="submit" disabled={sending} className="lq-btn-submit">
              {sending ? "⏳ Envoi en cours…" : "✔ OK confirmation et envoi"}
            </button>
            <button type="button" className="lq-btn-time">
              Timestamps
              <div className="lq-btn-time-sub">{timeStr}</div>
            </button>
          </div>

        </form>
      </div>

      {/* SCANNER */}
      {showScanner && (
        <div className="lq-modal-backdrop" onClick={() => setShowScanner(false)}>
          <div className="lq-modal-scanner" onClick={(e) => e.stopPropagation()}>
            <div className="lq-modal-title">📷 Scanner Stack Abouté</div>
            <div style={{ borderRadius: 10, overflow: "hidden" }}>
              <Scanner onScan={handleScan} onError={console.error} constraints={{ facingMode: "environment" }} />
            </div>
            <button type="button" className="lq-btn-close-scanner" onClick={() => setShowScanner(false)}>✕ Fermer</button>
          </div>
        </div>
      )}

      <Style />
    </div>
  );
}

/* ── UI HELPERS ── */
function YellowBox({ label, value, onChange }) {
  return (
    <div className="lq-yellow-card">
      <div className="lq-yellow-title">{label}</div>
      <input value={value} onChange={(e) => onChange(e.target.value)} className="lq-yellow-input" />
    </div>
  );
}
function GreenTag({ children }) { return <div className="lq-green-tag">{children}</div>; }
function DimField({ label, value, onChange, small }) {
  return (
    <div className="lq-dim-wrap">
      <div className={`lq-dim-label ${small ? "lq-dim-label-sm" : ""}`}>{label}</div>
      <input value={value} onChange={(e) => onChange(e.target.value)} className="lq-dim-input" />
    </div>
  );
}
function MiniField({ label, value, onChange }) {
  return (
    <div className="lq-mini-wrap">
      <div className="lq-mini-label">{label}</div>
      <input value={value} onChange={(e) => onChange(e.target.value)} className="lq-mini-input" />
    </div>
  );
}

/* ── STYLES ── */
function Style() {
  return (
    <style>{`
      *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

      .lq-page {
        min-height: 100vh; width: 100%;
        background: radial-gradient(ellipse at top,#01283a 0%,#010F14 70%);
        display: flex; justify-content: center; align-items: flex-start;
        padding: 16px; font-family: 'Inter','Segoe UI',sans-serif;
      }
      .lq-card {
        width: 100%; max-width: 760px;
        background: #011e2b; border: 1px solid #1a4a5a;
        border-radius: 16px; overflow: hidden;
        box-shadow: 0 8px 40px rgba(0,0,0,0.6), 0 0 0 1px #0a3040;
      }

      /* HEADER */
      .lq-header {
        background: linear-gradient(135deg,#E6FF3E,#c8e800);
        color: #000; padding: 14px 20px;
        display: flex; flex-direction: column; align-items: center; gap: 2px;
      }
      .lq-header span  { font-size: 15px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.1em; }
      .lq-header-sub   { font-size: 11px; font-weight: 500; opacity: 0.6; }

      /* NAV */
      .lq-nav {
        background: #010f14; padding: 8px 16px;
        display: flex; justify-content: space-between; align-items: center;
        border-bottom: 1px solid #1a4a5a;
      }
      .lq-btn-back {
        background: transparent; color: #7ab8cc;
        border: 1px solid #1a4a5a; border-radius: 6px;
        padding: 5px 10px; font-size: 11px; font-weight: 600; cursor: pointer; transition: all 0.2s;
      }
      .lq-btn-back:hover { background: #1a4a5a; color: #fff; }
      .lq-clock          { text-align: right; }
      .lq-clock-time     { color: #E6FF3E; font-size: 15px; font-weight: 700; font-variant-numeric: tabular-nums; }
      .lq-clock-date     { color: #5a8a99; font-size: 10px; }

      /* TOPBAR */
      .lq-topbar {
        padding: 12px 20px; display: flex; flex-direction: column; gap: 12px;
        border-bottom: 1px solid #1a4a5a;
      }
      .lq-operator {
        display: flex; align-items: center; gap: 10px;
        background: linear-gradient(90deg,#012836,#013d50);
        border: 1px solid #1a5a6a; border-radius: 10px;
        padding: 10px 14px; color: #fff; font-size: 13px; font-weight: 700; letter-spacing: 0.06em;
      }
      .lq-operator-dot { width: 10px; height: 10px; background: #00B050; border-radius: 50%; box-shadow: 0 0 6px #00B050; flex-shrink: 0; }
      .lq-stack-box   { display: flex; flex-direction: column; gap: 8px; }
      .lq-chip-red {
        background: #C00000; color: #fff; padding: 7px 12px;
        border-radius: 8px; font-weight: 800; font-size: 12px; text-align: center;
        border: 2px solid #7F0000; letter-spacing: 0.05em;
      }
      .lq-stack-row   { display: flex; gap: 8px; align-items: flex-start; }
      .lq-select-input {
        width: 100%; background: #003818; color: #7aff9a;
        border: 1px solid #005020; border-radius: 8px;
        padding: 10px 14px; font-size: 14px; font-weight: 600;
        outline: none; transition: border 0.2s;
      }
      .lq-select-input:focus { border-color: #00B050; box-shadow: 0 0 0 2px rgba(0,176,80,0.15); }
      .lq-scan-btn {
        width: 46px; height: 46px; flex-shrink: 0; background: #012030;
        border: 1px solid #1a4a5a; border-radius: 8px;
        font-size: 20px; cursor: pointer; transition: background 0.2s;
      }
      .lq-scan-btn:hover { background: #1a4a5a; }
      .lq-selected-badge {
        display: flex; align-items: center; gap: 8px; margin-top: 6px;
        background: #002810; border: 1px solid #00B050; border-radius: 8px;
        padding: 5px 12px; font-size: 12px; color: #7aff9a;
      }
      .lq-selected-badge strong { flex: 1; font-size: 13px; }
      .lq-clear-btn { background: transparent; border: none; color: #ff8080; cursor: pointer; font-size: 14px; font-weight: 700; }
      .lq-dropdown {
        position: absolute; left: 0; right: 0; margin-top: 4px;
        max-height: 200px; overflow-y: auto;
        background: #002818; border: 1px solid #005020; border-radius: 8px; z-index: 50;
        box-shadow: 0 8px 24px rgba(0,0,0,0.5);
      }
      .lq-dropdown-item {
        padding: 8px 14px; color: #aaffcc; font-size: 13px;
        cursor: pointer; border-bottom: 1px solid #003818; transition: background 0.15s;
      }
      .lq-dropdown-item:hover { background: #003d20; }

      /* FORM */
      .lq-form { padding: 16px 20px 24px; display: flex; flex-direction: column; gap: 14px; overflow-y: auto; flex: 1; }

      /* SECTIONS */
      .lq-section {
        background: #012030; border: 1px solid #1a4a5a;
        border-radius: 12px; padding: 14px 16px;
        display: flex; flex-direction: column; gap: 12px;
      }
      .lq-section-qr { border-color: #FFD966; background: #1a1400; }
      .lq-section-label  { font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: #7ab8cc; }
      .lq-label-green    { color: #7aff9a; }
      .lq-label-gray     { color: #c8c8d8; }

      /* GRIDS */
      .lq-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
      .lq-grid-3 { display: grid; grid-template-columns: repeat(3,1fr); gap: 10px; }
      .lq-grid-5 { display: grid; grid-template-columns: repeat(5,1fr); gap: 8px; margin-top: 4px; }

      /* TRAITEMENTS */
      .lq-yellow-card  { background: #FFD966; border: 2px solid #C00000; border-radius: 10px; padding: 10px; display: flex; flex-direction: column; gap: 6px; }
      .lq-yellow-title { font-weight: 900; font-size: 11px; text-align: center; color: #000; white-space: pre-line; line-height: 1.3; }
      .lq-yellow-input { background: #012836; color: #fff; border: 1px solid #eee; border-radius: 6px; padding: 8px; font-size: 12px; text-align: center; width: 100%; outline: none; }
      .lq-yellow-input:focus { border-color: #FFD966; }

      /* DÉFAUTS */
      .lq-defauts-grid { display: grid; grid-template-columns: minmax(140px,220px) 1fr; gap: 10px; align-items: center; }
      .lq-green-tag    { background: #00B050; color: #000; border: 2px solid #00702F; border-radius: 10px; padding: 10px; font-weight: 900; text-align: center; font-size: 12px; }
      .lq-gray-input   { background: #F2F2F2; color: #000; border: 2px solid #C00000; border-radius: 10px; padding: 10px; font-weight: 700; font-size: 12px; width: 100%; outline: none; }
      .lq-gray-input:focus { border-color: #900000; }

      /* DIMENSIONS */
      .lq-dim-wrap    { display: flex; flex-direction: column; gap: 6px; }
      .lq-dim-label   { background: #4D4D4D; color: #fff; border: 2px solid #7F7F7F; border-radius: 8px; padding: 8px; text-align: center; font-weight: 800; font-size: 12px; }
      .lq-dim-label-sm { font-size: 10px; padding: 6px 4px; }
      .lq-dim-input   { background: #012836; color: #fff; border: 1px solid #3a6a7a; border-radius: 6px; padding: 8px; font-size: 12px; text-align: center; outline: none; }
      .lq-dim-input:focus { border-color: #E6FF3E; }

      /* CONTRÔLE */
      .lq-ctrl-btn {
        padding: 14px 10px; border-radius: 10px; font-weight: 900; font-size: 13px;
        cursor: pointer; line-height: 1.4; transition: transform 0.1s, box-shadow 0.2s; border-width: 3px; border-style: solid;
      }
      .lq-ctrl-ok      { background: #00B050; color: #000; border-color: #00702F; }
      .lq-ctrl-nok     { background: #C00000; color: #fff; border-color: #7F0000; }
      .lq-ctrl-active  { box-shadow: 0 0 0 4px rgba(230,255,62,0.7); transform: scale(1.02); }

      /* MINI FIELDS */
      .lq-mini-wrap  { display: flex; flex-direction: column; gap: 5px; }
      .lq-mini-label { background: #4D4D4D; color: #fff; border: 2px solid #7F7F7F; border-radius: 8px; padding: 7px 6px; text-align: center; font-weight: 800; font-size: 11px; white-space: pre-line; }
      .lq-mini-input { background: #012836; color: #fff; border: 1px solid #3a6a7a; border-radius: 6px; padding: 7px 6px; font-size: 12px; text-align: center; outline: none; }
      .lq-mini-input:focus { border-color: #E6FF3E; }
      .lq-wide-input  { width: 100%; background: #012836; color: #fff; border: 1px solid #3a6a7a; border-radius: 8px; padding: 10px 12px; font-size: 13px; outline: none; margin-top: 4px; }
      .lq-wide-input:focus { border-color: #E6FF3E; }

      /* QR */
      .lq-qr-preview { background: #010f14; border: 1px dashed #FFD966; border-radius: 8px; padding: 10px 14px; font-size: 12px; color: #FFD966; font-family: monospace; word-break: break-all; text-align: center; }
      .lq-btn-qr-create {
        background: #FFD966; color: #000; border: 2px solid #C00000; border-radius: 10px;
        padding: 12px; font-weight: 800; font-size: 13px; cursor: pointer; transition: opacity 0.2s;
      }
      .lq-btn-qr-print {
        background: #FFD966; color: #000; border: 2px solid #C00000; border-radius: 10px;
        padding: 12px; font-weight: 800; font-size: 13px; cursor: pointer; transition: opacity 0.2s;
      }
      .lq-btn-qr-create:hover, .lq-btn-qr-print:hover:not(:disabled) { opacity: 0.85; }
      .lq-btn-qr-print:disabled { opacity: 0.6; cursor: not-allowed; }

      /* MESSAGES */
      .lq-msg         { border-radius: 8px; padding: 10px 14px; font-size: 13px; font-weight: 600; }
      .lq-msg-error   { background: #2a0808; border: 1px solid #C00000; color: #ff9090; }
      .lq-msg-success { background: #002810; border: 1px solid #00B050; color: #80ff90; }

      /* SUBMIT */
      .lq-submit-row  { display: flex; gap: 10px; align-items: center; }
      .lq-btn-submit  {
        flex: 1; background: linear-gradient(135deg,#00B050,#008a3c);
        color: #000; border: none; border-radius: 10px;
        padding: 14px; font-size: 15px; font-weight: 800;
        text-transform: uppercase; letter-spacing: 0.08em; cursor: pointer;
        transition: opacity 0.2s, transform 0.1s;
        box-shadow: 0 4px 16px rgba(0,176,80,0.3);
      }
      .lq-btn-submit:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); }
      .lq-btn-submit:disabled { opacity: 0.5; cursor: not-allowed; }
      .lq-btn-time {
        min-width: 120px; background: #C00000; color: #fff;
        border: 2px solid #7F0000; border-radius: 8px;
        padding: 8px 10px; font-weight: 700; font-size: 12px; cursor: default; text-align: center;
      }
      .lq-btn-time-sub { font-size: 11px; margin-top: 2px; font-variant-numeric: tabular-nums; }

      /* SCANNER MODAL */
      .lq-modal-backdrop {
        position: fixed; inset: 0; background: rgba(0,0,0,0.8);
        display: flex; justify-content: center; align-items: center;
        z-index: 999; backdrop-filter: blur(4px);
      }
      .lq-modal-scanner {
        width: 90%; max-width: 420px; background: #011e2b;
        border: 1px solid #00B050; border-radius: 14px; padding: 16px;
        display: flex; flex-direction: column; gap: 12px;
        box-shadow: 0 0 40px rgba(0,176,80,0.2);
      }
      .lq-modal-title { color: #fff; font-size: 14px; font-weight: 700; text-align: center; }
      .lq-btn-close-scanner {
        background: #C00000; color: #fff; border: none; border-radius: 8px;
        padding: 10px; font-weight: 700; font-size: 13px; cursor: pointer; transition: opacity 0.2s;
      }
      .lq-btn-close-scanner:hover { opacity: 0.85; }

      /* TABLETTE */
      @media (min-width: 768px) {
        .lq-card  { max-width: 900px; }
        .lq-header span { font-size: 18px; }
        .lq-form  { padding: 20px 28px 28px; gap: 18px; }
        .lq-select-input { font-size: 16px; }
        .lq-ctrl-btn { font-size: 14px; padding: 16px; }
        .lq-btn-submit { font-size: 16px; padding: 16px; }
        .lq-defauts-grid { grid-template-columns: 200px 1fr; }
      }

      /* DESKTOP */
      @media (min-width: 1024px) {
        .lq-card  { max-width: 1080px; }
        .lq-header span { font-size: 20px; }
        .lq-form  { padding: 20px 36px 36px; gap: 20px; }
        .lq-topbar { padding: 16px 36px; flex-direction: row; align-items: flex-start; gap: 20px; }
        .lq-operator { flex: 0 0 auto; align-self: center; min-width: 280px; font-size: 15px; }
        .lq-stack-box { flex: 1; }
        .lq-section { padding: 18px 20px; border-radius: 14px; }
        .lq-section-label { font-size: 13px; }
        .lq-select-input  { font-size: 18px; padding: 12px 16px; }
        .lq-scan-btn      { width: 54px; height: 54px; font-size: 24px; }
        .lq-yellow-title  { font-size: 12px; }
        .lq-yellow-input  { font-size: 13px; }
        .lq-green-tag     { font-size: 13px; padding: 12px; }
        .lq-gray-input    { font-size: 13px; padding: 12px; }
        .lq-dim-label     { font-size: 13px; }
        .lq-dim-input     { font-size: 13px; padding: 10px; }
        .lq-dim-label-sm  { font-size: 12px; }
        .lq-ctrl-btn      { font-size: 15px; padding: 18px; }
        .lq-mini-label    { font-size: 12px; }
        .lq-mini-input    { font-size: 13px; }
        .lq-wide-input    { font-size: 14px; }
        .lq-btn-qr-create, .lq-btn-qr-print { font-size: 14px; padding: 14px; }
        .lq-btn-submit    { font-size: 18px; padding: 18px; border-radius: 12px; }
        .lq-btn-time      { min-width: 160px; }
        .lq-defauts-grid  { grid-template-columns: 240px 1fr; }
      }

      /* XXL */
      @media (min-width: 1400px) {
        .lq-page  { padding: 32px; }
        .lq-card  { max-width: 1360px; border-radius: 20px; }
        .lq-header { padding: 24px 48px; }
        .lq-header span { font-size: 26px; letter-spacing: 0.14em; }
        .lq-header-sub  { font-size: 14px; }
        .lq-nav   { padding: 14px 36px; }
        .lq-clock-time  { font-size: 22px; }
        .lq-topbar { padding: 20px 48px; gap: 28px; }
        .lq-operator { font-size: 18px; padding: 14px 20px; border-radius: 12px; }
        .lq-operator-dot { width: 14px; height: 14px; }
        .lq-form  { padding: 24px 48px 40px; gap: 24px; }
        .lq-section { padding: 22px 24px; border-radius: 16px; }
        .lq-section-label { font-size: 15px; letter-spacing: 0.1em; }
        .lq-chip-red { font-size: 14px; padding: 10px 16px; }
        .lq-select-input  { font-size: 22px; padding: 14px 18px; border-radius: 10px; height: 62px; }
        .lq-scan-btn      { width: 66px; height: 66px; font-size: 28px; border-radius: 10px; }
        .lq-dropdown-item { font-size: 15px; padding: 10px 16px; }
        .lq-yellow-card   { padding: 14px; border-radius: 12px; }
        .lq-yellow-title  { font-size: 14px; }
        .lq-yellow-input  { font-size: 15px; padding: 10px; border-radius: 8px; }
        .lq-green-tag     { font-size: 14px; padding: 14px; border-radius: 12px; }
        .lq-gray-input    { font-size: 14px; padding: 14px; border-radius: 10px; }
        .lq-defauts-grid  { grid-template-columns: 280px 1fr; gap: 14px; }
        .lq-dim-label     { font-size: 14px; padding: 10px; border-radius: 10px; }
        .lq-dim-input     { font-size: 15px; padding: 12px; border-radius: 8px; }
        .lq-dim-label-sm  { font-size: 12px; }
        .lq-ctrl-btn      { font-size: 18px; padding: 22px; border-radius: 12px; }
        .lq-mini-label    { font-size: 13px; padding: 8px; border-radius: 10px; }
        .lq-mini-input    { font-size: 14px; padding: 9px; border-radius: 8px; }
        .lq-wide-input    { font-size: 16px; padding: 14px 18px; border-radius: 10px; }
        .lq-qr-preview    { font-size: 14px; padding: 12px 16px; border-radius: 10px; }
        .lq-btn-qr-create, .lq-btn-qr-print { font-size: 16px; padding: 16px; border-radius: 12px; }
        .lq-msg           { font-size: 15px; padding: 14px 18px; border-radius: 10px; }
        .lq-btn-submit    { font-size: 22px; padding: 22px; border-radius: 14px; letter-spacing: 0.1em; }
        .lq-btn-time      { min-width: 180px; font-size: 14px; padding: 14px; border-radius: 10px; }
        .lq-btn-time-sub  { font-size: 13px; }
      }
    `}</style>
  );
}
